module.exports = __webpack_public_path__ + "img/logo_tvb.206da1d5.png";